import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Role } from '../data/types/medico.types';
 
const getNavigateTo = (role: Role
) => {
	if (role === Role.PACIENTE) return '/app/login'
	else if (role === Role.ADMIN || role === Role.MEDICO) return '/med/login'
	else return '/' // LANDING PAGE
}

const ProtectedRoute = () => {
  const { token, role } = useAuth();
  return token ? <Outlet /> : <Navigate to={getNavigateTo(role as Role)} replace />;
};
 
export default ProtectedRoute;